<button size="small" p-button  class="ml-3 split-button-orange-1" type="button" (click)="showOverlayPanel($event)">{{_filter.name}}</button>
<p-overlayPanel #op (onHide)="hideOverlayPanel()" appendTo="body">
    <ng-container [ngSwitch]="_filter.type">
        <ng-container *ngSwitchCase="'DROPDOWN'">
            <div class="split-dropdown-panel">
                <div class="split-dropdown-header">
                    <split-search (valueChange)="search($event)"></split-search>
                </div>
                <div class="split-dropdown-list">
                    <div class="split-dropdown-item" *ngFor="let data of _filter.data; let i = index">
                        <p-checkbox (click)="$event.stopPropagation()" [ngModel]="_filter.data[i]?.checklist" (onChange)="change($event, i)" [binary]="true" [inputId]="data.code"></p-checkbox>
                        <label class="ml-1" [for]="data.code">{{data.value}}</label>
                    </div>
                </div>
                <div class="split-dropdown-footer">
                    <p-button (click)="emit()" label="aplicar"></p-button>
                </div>
              </div>
        </ng-container>
        <ng-container *ngSwitchCase="'DATE'">
            <div class="split-calendar-panel flex w-full">
                <p-calendar (click)="$event.stopPropagation()" [(ngModel)]="_filter.data" class="w-full" selectionMode="range" [inline]="true" >
                    <ng-template pTemplate="header">
                        <div class="flex align-items-center justify-content-center mb-3">
                            <p-inputMask [ngModel]="_filter.data[0] | date:'dd/MM/yyyy'" (onInput)="inputDate($event, 0)" mask="99/99/9999"></p-inputMask>
                            <split-icon class="mx-3" name="arrow-narrow-right"></split-icon>
                            <p-inputMask [ngModel]="_filter.data[1] | date:'dd/MM/yyyy'"  (onInput)="inputDate($event, 1)"  mask="99/99/9999"></p-inputMask>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <div class="flex justify-content-between mt-3">
                            <p-button (click)="cancel()" label="cancelar" [outlined]="true"  severity="secondary"></p-button>
                            <p-button (click)="emit()" label="aplicar"></p-button>
                        </div>
                    </ng-template>
                </p-calendar>
            </div>
        </ng-container>
    </ng-container>
</p-overlayPanel>

<!--<ng-container  [ngSwitch]="type">
    <ng-container *ngSwitchCase="'DROPDOWN'">
        <div class="split-dropdown-panel">
            <div class="split-dropdown-header">
                <split-search (valueChange)="search($event)"></split-search>
            </div>
            <div class="split-dropdown-list">
                <div class="split-dropdown-item" *ngFor="let option of optionsFilter; let i = index">
                    <p-checkbox (click)="$event.stopPropagation()" [ngModel]="selected.data[i]?.checklist" (onChange)="change($event, i)" [binary]="true" [inputId]="option.code"></p-checkbox>
                    <label class="ml-1" [for]="option.code">{{option.value}}</label>
                </div>
            </div>
            <div class="split-dropdown-footer">
                <p-button (click)="emit()" label="aplicar"></p-button>
            </div>
          </div>
    </ng-container>
    <ng-container *ngSwitchCase="'DATE'">
        <div class="flex w-full">
            <p-calendar [(ngModel)]="selected.data" class="w-full" selectionMode="range" [inline]="true" >
                <ng-template pTemplate="header">
                    <div class="flex align-items-center justify-content-center mb-3">
                        <p-inputMask [ngModel]="selected.data[0] | date:'dd/MM/yyyy'" (onInput)="configDate($event, 0)" mask="99/99/9999"></p-inputMask>
                        <split-icon class="mx-3" name="arrow-narrow-right"></split-icon>
                        <p-inputMask [ngModel]="selected.data[1] | date:'dd/MM/yyyy'"  (onInput)="configDate($event, 1)"  mask="99/99/9999"></p-inputMask>
                    </div>
                </ng-template>
                <ng-template pTemplate="footer">
                    <div class="flex justify-content-between mt-3">
                        <p-button (click)="cancel()" label="cancelar" [outlined]="true"  severity="secondary"></p-button>
                        <p-button (click)="emit()" label="aplicar"></p-button>
                    </div>
                </ng-template>
            </p-calendar>
        </div>
    </ng-container>
</ng-container>-->
